export const AUTH_TOKEN = 'AUTH_TOKEN'
export const LANGUAGE = 'LANGUAGE'
export const USER_DATA = 'USER_DATA'
export const LIST_POINT_OF_SALES = "LIST_POINT_OF_SALES"